<template>
  <ApplicationLayout
    :user="user"
    :options="options"
    :version="version"
    :links="links"
    :showActionItems="true"
  >
    <!-- Set System bar content if enabled-->
    <template #systembar>
      <v-alert
        class="py-0 ma-0"
        style="left: 0; right: 0; position: absolute"
        :color="alertColor"
        dark
        v-html="systemMessageOptions.systemMessage"
      >
      </v-alert>
    </template>

    <!-- Set Appbar title-->
    <template #title>
      <CaseFileModal ref="caseFile" />
      <v-icon class="mr-2">mdi-scale-balance</v-icon>
      <v-toolbar-title class="font-weight-bold d-flex">
        {{
          activeModuleNames.find((m) => m.toLowerCase().includes('delinquency'))
        }}
      </v-toolbar-title>
    </template>
    <!-- Use to add addition items to Appbar -->
    <template #toolbar>
      <!-- <GlobalNotificationButton
        :moduleName="'Delinquency-Pro'"
        :defaultEmails="[]"
        :defaultPhones="[]"
      /> -->
      <FollowUpActionsMenu />
      <NotificationMenu :notifications="notificationHistory.notifications" />
      <ReportIssueButton />
      <div class="mr-2" />
      <!-- <v-btn
        depressed
        @click="$refs.caseFile.open()"
        class="border-1 mr-6"
      >
        <v-icon>mdi-plus</v-icon>
        <span class="ml-2 d-none d-md-flex">New Case File</span>
      </v-btn> -->
    </template>

    <!-- Use change Navbar header content-->
    <template #navheader> </template>

    <!-- Use display content-->
    <template #content>
      <router-view />
    </template>
  </ApplicationLayout>
</template>

<script>
import ApplicationLayout from '@/modules/shared/components/core/layouts/ApplicationLayout.vue';
import NotificationMenu from '@/modules/shared/components/core/NotificationMenu.vue';
import ReportIssueButton from '@/modules/shared/components/core/ReportIssueButton.vue';
import PageMixin from '@/mixins/page.mixin';
import delinquencyLinks from '@/modules/delinquency/routes/links';
import CaseFileModal from '@/modules/delinquency/components/manual-case-file/CaseFileModal.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { CaseManagementService } from '../services/case-management.service';
import FeatureFlagMixin from '@/mixins/feature.mixin';
import AccessControlMixin from '@/mixins/accessControl.mixin';
import SocketMixin from '@/modules/delinquency/mixins/socket.mixin';
import FollowUpActionsMenu from '@/modules/shared/components/follow-up-actions/FollowUpActionsMenu.vue';

const layoutOptions = {
  showSystemBar: false,
  showSearchBar: false,
  showUserOptions: true,
  showMenuToggle: true,

  appBarColor: 'white',
  mainContentClass: 'grey lighten-5',
  miniDrawerColor: '',
  miniDrawerIconsColor: 'white',
  leftDrawerColor: 'white',
  leftDrawerIconsColor: ''
};

export default {
  name: 'DelinquencyLayout',

  components: {
    ApplicationLayout,
    ReportIssueButton,
    CaseFileModal,
    NotificationMenu,
    FollowUpActionsMenu
  },
  mixins: [PageMixin, FeatureFlagMixin, AccessControlMixin, SocketMixin],

  data: () => ({
    name: 'layout',
    options: layoutOptions,
    alertColor: 'primary'
  }),

  computed: {
    ...mapGetters('appModulesModule', ['activeModuleNames']),
    ...mapGetters('authModule', ['user']),
    ...mapGetters('delinquencyLayoutModule', ['systemMessageOptions']),
    ...mapGetters('featureFlagModule', ['delinquencyFeatures']),
    ...mapState('userNotificationsModule', ['notificationHistory']),
    links() {
      if (!this.delinquencyFeatures) {
        return [];
      }

      const isVisible = (link) => {
        const featureCheck = !link.featureKey || this.hasFeature(link.featureKey);
        const privilegeCheck = this.userHasPrivilege(link.requiredPrivileges);
        return featureCheck && privilegeCheck;
      };
      return delinquencyLinks.reduce((acc, link) => {
        if (isVisible(link)) {
          if (link.items && Array.isArray(link.items)) {
            const visibleItems = link.items.filter(isVisible);
            if (visibleItems.length > 0) {
              acc.push({ ...link, items: visibleItems });
            }
          } else {
            acc.push(link);
          }
        }
        return acc;
      }, []);
    }
  },

  async created() {
    this.updateBadgeCount();
    this.loadNotifications({ userId: this.user.id, appName: this.appName });
  },

  methods: {
    ...mapActions('userNotificationsModule', ['loadNotifications']),

    async updateBadgeCount() {
      const statsService = new CaseManagementService();

      const { data: badgeCountRes } = await statsService.getWorkloadCount(
        this.user.id
      );
      delinquencyLinks.forEach((e, index) => {
        if (e.id === 'workload') {
          let total = 0;
          const workloadChildren = e.items?.map((el) => {
            let count = badgeCountRes[el.id];
            total += count;

            el.badgeText = '0';
            el.badgeText = `${count}`;

            return el;
          });

          e.items = workloadChildren;
          e.badgeText = total || '0';
          this.links.splice(index, 1, e);
        }
      });

      console.log('links updated.....');
    }
  },

  mounted() {},

  watch: {
    systemMessageOptions: {
      handler: function (newOptions) {
        this.options.showSystemBar = !!newOptions?.systemMessage;
        this.alertColor = newOptions?.systemBarColor || 'primary';
      }
    }
  }
};
</script>
